import { getStoreStyleName } from 'arena-shared';
import { getOwnedStyleIds } from './augments';
import {
  clashWinnerIconToApi,
  clashWinnerIconSrc,
  formatClashWinnerIcon
} from './clashWinnerIcon';

const WINNER_BADGE_BASE = [
  { code: 'c', label: 'Crown' },
  { code: 'l', label: 'L' },
  { code: 'f', label: 'Flex' }
];

/**
 * Equip options for Account → Clash winner badge.
 * Always includes base Crown / L / Flex; adds each owned style (Crystal, Gold, …).
 * @param {{ s?: Record<string, number[]> }} inventory
 * @returns {{ key: string, apiValue: string, label: string, src: string }[]}
 */
export function getClashWinnerBadgeEquipOptions(inventory) {
  const options = [];
  for (const { code, label } of WINNER_BADGE_BASE) {
    options.push({
      key: code,
      apiValue: clashWinnerIconToApi(code),
      label,
      src: clashWinnerIconSrc(code)
    });
    for (const styleId of getOwnedStyleIds(inventory, code)) {
      const styled = formatClashWinnerIcon(code, styleId);
      options.push({
        key: styled,
        apiValue: clashWinnerIconToApi(styled),
        label: `${label} ${getStoreStyleName(styleId)}`,
        src: clashWinnerIconSrc(styled)
      });
    }
  }
  return options;
}
